<nav class="navbar navbar-expand-lg main-nav navbar-dark" aria-label="Primary">
  <div class="container-fluid main-nav__container">
    <div class="navbar-collapse main-nav__desktop">
      <ul class="navbar-nav me-auto mb-0 main-nav__primary">
        <li class="nav-item" [class.active]="isCurrentRoute('/home', true)">
          <a class="nav-link" routerLink="/home">
            <fa-icon [icon]="faHome"></fa-icon>
            Home
          </a>
        </li>

        @for (section of primarySections; track section.id) {
          <li class="nav-item dropdown" ngbDropdown display="dynamic" placement="bottom-start">
            <button
              type="button"
              class="nav-link dropdown-toggle"
              [id]="'desktop-section-' + section.id"
              ngbDropdownToggle
              [class.active]="isSectionActive(section)">
              <fa-icon [icon]="section.icon"></fa-icon>
              {{ section.label }}
            </button>
            <div ngbDropdownMenu [attr.aria-labelledby]="'desktop-section-' + section.id">
              @for (item of section.items; track item.route) {
                @if (item.external) {
                  <a ngbDropdownItem [href]="item.route" target="_blank" rel="noopener noreferrer">
                    {{ item.label }}
                  </a>
                } @else {
                  <button ngbDropdownItem [routerLink]="item.route">{{ item.label }}</button>
                }
              }
            </div>
          </li>
        }
      </ul>

      <ul class="navbar-nav ms-lg-auto mb-0 main-nav__secondary">
        @if (isAuthenticated) {
          <li class="nav-item dropdown" ngbDropdown display="dynamic" placement="bottom-end">
            <button type="button" class="nav-link dropdown-toggle" id="desktop-user-menu" ngbDropdownToggle>
              <fa-icon [icon]="faUser"></fa-icon>
              {{ currentUserLabel }}
            </button>
            <div ngbDropdownMenu aria-labelledby="desktop-user-menu">
              @if (canResetPassword) {
                <button ngbDropdownItem (click)="requestPasswordReset(resetPasswordConfirmContent)">
                  <fa-icon [icon]="faKey"></fa-icon>
                  Reset Password
                </button>
              }
              <button ngbDropdownItem (click)="logout()">Logout</button>
            </div>
          </li>
        }

        @if (!isAuthenticated) {
          <li class="nav-item" [class.active]="isCurrentRoute('/login', true)">
            <a class="nav-link main-nav__login" routerLink="/login">
              <fa-icon [icon]="faSignInAlt"></fa-icon>
              Login
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>

@if (isMobileMenuOpen) {
  <section
    #mobileOverlay
    id="mobileNavigation"
    class="main-nav__overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Primary navigation"
    tabindex="-1">
    <div class="main-nav__overlay-brand-shell">
      <app-main-header class="main-nav__overlay-brand"></app-main-header>
    </div>

    <div class="main-nav__overlay-body">
      <a
        class="main-nav__overlay-link"
        [class.main-nav__overlay-link--active]="isCurrentRoute('/home', true)"
        routerLink="/home"
        (click)="closeMenuAndNavigate()">
        <span class="main-nav__overlay-link-copy">
          <fa-icon [icon]="faHome"></fa-icon>
          Home
        </span>
        <fa-icon [icon]="faChevronRight" aria-hidden="true"></fa-icon>
      </a>

      <div
        ngbAccordion
        #mobileAccordion="ngbAccordion"
        class="main-nav__overlay-accordion"
        [closeOthers]="true"
        [destroyOnHide]="false">
        @for (section of primarySections; track section.id) {
          <div ngbAccordionItem [ngbAccordionItem]="section.id" class="accordion-item main-nav__overlay-card">
            <h2 ngbAccordionHeader class="accordion-header">
              <button
                ngbAccordionButton
                type="button"
                class="accordion-button main-nav__overlay-button"
                [class.main-nav__overlay-button--current]="isSectionActive(section)">
                <span class="main-nav__overlay-link-copy">
                  <fa-icon [icon]="section.icon"></fa-icon>
                  {{ section.label }}
                </span>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <div class="main-nav__overlay-submenu">
                    @for (item of section.items; track item.route) {
                      @if (item.external) {
                        <a
                          class="main-nav__overlay-subitem"
                          [href]="item.route"
                          target="_blank"
                          rel="noopener noreferrer"
                          (click)="closeMenu()">
                          {{ item.label }}
                        </a>
                      } @else {
                        <a
                          class="main-nav__overlay-subitem"
                          [class.main-nav__overlay-subitem--active]="isCurrentRoute(item.route, item.exact ?? false)"
                          [routerLink]="item.route"
                          (click)="closeMenuAndNavigate()">
                          {{ item.label }}
                        </a>
                      }
                    }
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>

      @if (isAuthenticated) {
        @if (canResetPassword) {
          <button
            type="button"
            class="main-nav__overlay-link main-nav__overlay-link--action"
            (click)="requestPasswordReset(resetPasswordConfirmContent)">
            <span class="main-nav__overlay-link-copy">
              <fa-icon [icon]="faKey"></fa-icon>
              Reset Password
            </span>
            <fa-icon [icon]="faChevronRight" aria-hidden="true"></fa-icon>
          </button>
        }

        <button type="button" class="main-nav__overlay-link main-nav__overlay-link--action" (click)="logout()">
          <span class="main-nav__overlay-link-copy">
            <fa-icon [icon]="faArrowRightFromBracket"></fa-icon>
            Logout
          </span>
          <fa-icon [icon]="faChevronRight" aria-hidden="true"></fa-icon>
        </button>
      }

      @if (!isAuthenticated) {
        <a class="main-nav__overlay-link main-nav__overlay-link--action" routerLink="/login" (click)="closeMenuAndNavigate()">
          <span class="main-nav__overlay-link-copy">
            <fa-icon [icon]="faSignInAlt"></fa-icon>
            Login
          </span>
          <fa-icon [icon]="faChevronRight" aria-hidden="true"></fa-icon>
        </a>
      }
    </div>
  </section>
}

<ng-template #resetPasswordConfirmContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Reset Password</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>Send a password reset email to your account email address?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel click')">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isPasswordResetSubmitting"
      (click)="modal.close('Confirm click')">
      Send Email@if(isPasswordResetSubmitting){<i class="fa fa-spinner fa-spin ms-2"></i>}
    </button>
  </div>
</ng-template>
